import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const DEFAULT_SAFE_OFFSET: NonNullable<ToasterProps["offset"]> = {
  top: "calc(var(--safe-area-top, 0px) + 12px)",
  right: 12,
  bottom: "calc(var(--safe-area-bottom, 0px) + 12px)",
  left: 12,
};

// Toast (Sonner) disattivati in tutta l'app: non renderizza nulla.
const Toaster = (_props: ToasterProps) => null;

export { Toaster, toast };
